import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('@/views/layouts/index'),
    redirect: '/home',
    meta: {
      title: '首页',
    },
    children: [
      {
        path: '/home',
        name: 'Home',
        component: () => import('@/views/home/index'),
        meta: { title: '首页', }
      },
      {
        path: '/upload',
        name: 'Upload',
        component: () => import('@/views/upload/index'),
        meta: { title: '上传', auth: true }
      },
      {
        path: '/picture',
        name: 'Picture',
        component: () => import('@/views/picture/index'),
        meta: { title: '我的作品', auth: true }
      },
      {
        path: '/list',
        name: 'List',
        component: () => import('@/views/list/index'),
        meta: { title: '优秀作品', }
      },
      // {
      //   path: '/details',
      //   name: 'Details',
      //   component: () => import('@/views/details/index'),
      //   meta: { title: '作品详情', }
      // },
      {
        path: '/rule',
        name: 'Rule',
        component: () => import('@/views/rule/index'),
        meta: { title: '规则', }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  scrollBehavior: () => ({ y: 0 }),
  routes
})

export default router